import React from 'react'
import { Box } from '@ally/metronome-ui'
import { reorderListItemLabel } from '../../constants'
import { KeyValPair } from '../../types'

const LobTypeItem: React.FC<{ name: string }> = ({ name }) => {
  return (
    <Box display="flex" alignItems="center" fontWeight="bold" pl="xs">
      {reorderListItemLabel[name as keyof KeyValPair]}
    </Box>
  )
}

export default LobTypeItem
